var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","hide-details":"","value":_vm.value,"items":_vm.ops,"label":_vm.label,"readonly":_vm.readonly,"clearable":_vm.clearable},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }